<template>
  <footer class="app-footer">
    <div class="container">
      <p>&copy; 2025 inboxmaster.ai. All Rights Reserved.</p>
      <div class="footer-links">
        <a href="/privacy-policy" target="_blank">Privacy Policy</a>
        <span class="separator"> • </span>
        <a href="/terms-of-use" target="_blank">Terms of Use</a>
        <span class="separator"> • </span>
        <a href="mailto:info@inboxmaster.ai">Support</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFooter",
});
</script>

<style scoped>
.app-footer {
  background-color: #fff;
  padding: 20px 0;
  text-align: center;
  box-shadow: 0 -1px 4px rgba(0,0,0,0.1);
}

.footer-links {
  margin-top: 1rem;
  font-size: 0.9rem;
}

.footer-links a {
  color: black;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: var(--primary-color);
}
</style> 